import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import { translate } from "react-i18next";
import i18n from "../i18n";

import CiPDF from "../pdfs/Critical Illness Forms.pdf";
import DisabilityPDF from "../pdfs/Disability Forms.pdf";
import LifePDF from "../pdfs/Life Forms.pdf";
import FAQE from "../pdfs/FAQE.pdf";

import CiFrPDF from "../pdfs/Formulaires Maladie Grave.pdf";
import DisabilityFrPDF from "../pdfs/Formulaires Invalidite.pdf";
import LifeFrPDF from "../pdfs/Formulaires Deces.pdf";
import FAQF from "../pdfs/FAQF.pdf";


const phoneStyle = {
  lineHeight: "normal",
  fontFamily: "Open Sans Light,Arial,sans-sarif",
  textDecoration: "underline",
  fontStyle: "normal",
  whiteSpace: "nowrap"
}

const largerPhoneStyle = {
  lineHeight: "normal",
  fontFamily: "Open Sans Light,Arial,sans-sarif",
  textDecoration: "underline",
  fontStyle: "normal",
  whiteSpace: "nowrap",
  fontSize: "1.15em",
  fontWeight: "400",
  marginTop: "28px",
  marginBottom: "28px"
};

export class Landing_Page extends Component {
  constructor(props) {
    super();
  }

  render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <Row>
          <Col sm="6">
            <Col sm="12">
              <h1>{t("landing_page.header1")}</h1>
              <h3>{t("landing_page.header2")}</h3>
              <Link to="/SectionIntro">
                <p>
                  <u>{t("landing_page.disabilityLink")}</u>
                </p>
              </Link>
            </Col>
            <Col sm="12">
              <h3>
                {t("landing_page.header3")}
                <a style={largerPhoneStyle} href="tel:18005497227">
                  {t("common.phone")}
                </a>
              </h3>
              <p> {t("landing_page.lifeLink")}</p>
              <p> {t("landing_page.ciLink")}</p>
              <p> {t("landing_page.empLink")}</p>
              </Col>
          </Col>
          <Col sm="6">
            <h1>{t("landing_page.header4")}</h1>
            <h3>{t("landing_page.subheader1")}</h3>
            <p>{t("landing_page.paragraph1")}</p>
            <p>
              {t("landing_page.paragraph2")}
              <a style={phoneStyle} href="tel:18005497227">
                {t("common.phone")}
              </a>
            </p>
            <h3>{t("landing_page.subheader2")}</h3>
            <p>{t("landing_page.paragraph3")}</p>
            <h4>{t("landing_page.paragraph4")}</h4>
            <div hidden={i18n.language.includes("en") ? false : true}>
              <ul>
                <li>
                  <a href={DisabilityPDF} target="_blank">
                    {t("landing_page.disForm")}
                  </a>
                </li>
                <li>
                  <a href={LifePDF} target="_blank">
                    {t("landing_page.lifeForm")}
                  </a>
                </li>
                <li>
                  <a href={CiPDF} target="_blank">
                    {t("landing_page.ciForm")}
                  </a>
                </li>
              </ul>
            </div>
            <div hidden={i18n.language.includes("fr") ? false : true}>
              <ul>
                <li>
                  <a href={DisabilityFrPDF} target="_blank">
                    {t("landing_page.disForm")}
                  </a>
                </li>
                <li>
                  <a href={LifeFrPDF} target="_blank">
                    {t("landing_page.lifeForm")}
                  </a>
                </li>
                <li>
                  <a href={CiFrPDF} target="_blank">
                    {t("landing_page.ciForm")}
                  </a>
                </li>
              </ul>
            </div>
          </Col>          
        </Row>
        <Row>
        <Col sm="6">
          <Col sm="12">
              <p>  <a href={i18n.language.includes("en") ? FAQE : FAQF} target="_blank">
                    {t("landing_page.faqPdf")}
                  </a>
              </p>
          </Col>
        </Col>
        <Col sm="6">  
        <h3>{t("landing_page.subheader3")}</h3>
          <p>
          <a href="https://ia.ca/track/search">
            {t("landing_page.trackerLink")}
          </a>
          </p>
        </Col>
        </Row>

        <Row>
        <Col sm="12">
            <p>{t("landing_page.emailSecurityMsg")}</p>
        </Col>
        </Row>        
      </React.Fragment>
    );
  }
}

export default translate("translate")(Landing_Page);
